import React, { useState, useEffect, useCallback } from 'react';
import { Table, Form, Button, Select, Checkbox, Popconfirm, notification } from 'antd';
import styled from 'styled-components'
import * as _ from 'lodash'
import axios from 'axios'
import { PlusOutlined } from '@ant-design/icons';
import ChannelModal from './ChannelModal';

const UserChannels = ({userIds, selected}) => {

  const [form] = Form.useForm();

  const [templateOptions, setTemplateOptions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [channels, setChannels] = useState([]);
  const [visible, setVisible] = useState(false)
  const [selectedChannel, setSelectedChannel] = useState(null);
  const [selectedTemplate, setSelectedTemplate] = useState([])

  const loadChannels = useCallback(() => {
    if(userIds.length === 0) return;
    setLoading(true);
    axios.post('/api/wt/userman/channelstab/read', { ids: userIds }).then((res) => {

      const { deliveries, notificationTemplates } = res.data.data;

      setChannels(deliveries);
      setTemplateOptions([{id: "", name: ""}, ..._.orderBy(notificationTemplates, ['name'], 'asc')]);

      setLoading(false);
    })
  }, [userIds, setLoading, setChannels])

  useEffect(() => {
    setSelectedTemplate(_.find(templateOptions, { default: true })?.id || '')
    form.resetFields()
  }, [form, templateOptions])

  useEffect(() => {
    userIds && selected && loadChannels()
  }, [userIds, selected, loadChannels])

  const onCheckboxClick = (record) => {

    setLoading(true);

    let r = {...record};
    r.enabled = !record.enabled;

    axios.post('/api/wt/userman/channelstab/update', { channelsTab: { deliveries: [r]}}).then((res) => {
      loadChannels();
      notification.success({ message: `Channel updated.` });
    }).catch((err) => {
      notification.error({ message: `Failed to update channel.` })
    });
  }

  const defaultColumns = [
    {
      title: 'Delivery Name',
      dataIndex: 'name',
      width: '33%',
    },
    {
      title: 'Active',
      dataIndex: 'enabled',
      align: 'center',
      width: '33%',
      render: (text, record) => (
        <Checkbox checked={record.enabled} onChange={() => onCheckboxClick(record)}/>
      ),
    },
    {
      title: '',
      dataIndex: 'operation',
      render: (text, record) => {
        return (
          <>
            <RowAction onClick={() => { setSelectedChannel(record); setVisible(true); }}>
              Edit
            </RowAction>
            {!record.default &&
              <Popconfirm placement="topLeft" title="Delete this channel?" onConfirm={() => deleteChannel(record.id)}> 
                <RowAction style={{marginLeft: '10px', color: '#c36f72'}}>Delete</RowAction>
              </Popconfirm>
            }
          </>
        );
      },
    },
  ];

  if(userIds.length > 1) {
    defaultColumns.unshift({
      title: 'User',
      dataIndex: 'userId',
      width: '33%',
    })
  }
  else {
    defaultColumns.unshift({
      title: 'Channel',
      dataIndex: 'description',
      width: '33%',
    })
  }
  
  const deleteChannel = (id) => {

    axios.post('/api/wt/userman/delivery/delete', { id: userIds[0], deliveries: [id] }).then((res) => {

      if(res.data.errors.length > 0) {
        console.error(res.data.errors)
        notification.error({ message: `Channel could not be deleted.` });
      }
      else {
        loadChannels();
        notification.success({ message: `Channel deleted.` });
      }
    })
  }
  
  const closeDialog = (reload) => {
    reload && loadChannels();
    setVisible(false);
  }

  const onAdd = () => {

    const newData = {
      channelId: 1,
      description: "SMTP",
      userId: userIds[0]
    }

    setSelectedChannel(newData);
    setVisible(true);
  }

  const afterClose = () => {
    setSelectedChannel(null);
  }

  const onSelect = (value) => {
    setSelectedTemplate(value);

    axios.post('/api/wt/userman/channelstab/update', { ids: userIds, channelsTab: { notifyTemplates: [{ id: value, default: true}]} }).then((res) => {
      notification.success({ message: `Notification template changed.` });
    }).catch((err) => {
      notification.error({ message: `Failed to update notification template.` })
    });
  }

  return (
    <Content>
      <Form
        form={form}
        name="userChannelsForm"
        labelAlign="left"
        autoComplete="off"
        hideRequiredMark
      >
        {userIds.length === 1 &&
          <ButtonContainer>
            <Button
              onClick={onAdd}
              type="primary"
              style={{ marginBottom: '10px', float: 'right' }}
              icon={<PlusOutlined />}
            >
              Add Channel
            </Button>
          </ButtonContainer>
        }
      <Form.Item label="Notification Template" style={{marginBottom: '10px'}}>
        <Select
          loading={loading}
          value={selectedTemplate}
          onSelect={onSelect}
        >
          {templateOptions.map(template =>
            <Select.Option
              key={template.id}
              value={template.id}
            >
              {template.name}
            </Select.Option>)}
        </Select>
      </Form.Item>
      {channels &&
        <Table
          size="small"
          dataSource={channels}
          columns={defaultColumns}
          rowClassName="editable-row"
          pagination={false}
          rowKey="id"
          loading={loading}
        />
      }
      <ChannelModal visible={visible} closeDialog={closeDialog} getContainer=".modal-mount" width="450px" channelData={selectedChannel} afterClose={afterClose}/>
      </Form>
    </Content>
  );
}

const Content = styled.div`
  margin: 0;
`
const ButtonContainer = styled.div`
  width: 100%;
  overflow: hidden;
`
const RowAction = styled.span`
  color: #2269a4;
  cursor: pointer;
  :hover {
    color: #4182b0;
  }
`

export default UserChannels;